import { RouteRecordRaw } from 'vue-router';
import { ProfilePage } from '@/pages/profile';

export const routeName = 'Perfil';

export const route: RouteRecordRaw = {
  path: 'perfil',
  name: routeName,
  component: ProfilePage,
};
